export default __webpack_public_path__ + "static/uoft-680aa6b82d8800b298cf8412b420013c.svg";